import { getJson } from "../../../api";
import { DeskInventoryFiltersGroupedByType } from "../domain";

export async function getFloorInventories(
  organizationId: string,
  floorId: string | undefined
): Promise<DeskInventoryFiltersGroupedByType[]> {
  const response = await getJson<DeskInventoryFiltersGroupedByType[]>(
    `/api/desk-inventories/grouped-by-type/floors/${floorId}`,
    {
      "filter.organization.id": organizationId,
    }
  );
  return response;
}
